import { request } from "../../api/api"

export const getUsers = (page = 1, pageSize = 10, status = '',search = '')=>{
    const params = new URLSearchParams({
        page,
        page_size: pageSize,
    });
    if(status && status !== "All"){
        params.append('status', status);
    }
    if (search) {
        params.append('search', search);
    }
    return request.get(`/users/?${params.toString()}`)
}
export const getUserId =(id)=>{
    return request.get(`/users/${id}/`)
}
export const addUsers =(data)=>{
    return request.post("/users/",data)
}
export const updateUsers =(id,data)=>{
    return request.put(`/users/${id}/`,data)
}

export const deleteUsers =(id)=>{
    return request.delete(`/users/${id}/`)
}